import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import LandingHeader from "../Components/LandingHeader";
import ReactDatatable from "@ashvin27/react-datatable";
import { NavLink } from "react-router-dom";
import { Images } from "../Components/Images";
import InnerFooter from "../Components/InnerFooter";
import { getAccount } from "../Hooks/useAccount";
import { getsupportTicket } from "../actions/markets";
import { momentFormat } from "../lib/dateTimeHelper";
import Header from "../layout/Header";
import NewFooter from "../layout/Footer";
const SupportTicket = () => {
  const user = getAccount();
  const [records, setrecords] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5); // Number of records per page
  const [count, setCount] = useState(0);
  const [incIndex, setincIndex] = useState(0);


  useEffect(() => {
    GetSupportTicket(page, limit);
  }, [page, limit]);

  const handlePagination = async (index) => {
    let uptpage = index.page_number;
    let uptlimit = index.page_size;

    // let skip = (index.page_number - 1) * index.page_size;
    // let loadinterval = index.page_number * index.page_size;
    setPage(uptpage);
    setLimit(uptlimit);
    console.log("dvsdvsdvsd", limit, uptpage, limit * uptpage - limit);

    setincIndex(limit * uptpage - limit)

    // GetSupportTicket(uptpage,uptlimit)
    // setInterval(loadinterval);
  };

  async function GetSupportTicket(page, limit) {
    try {
      console.log("sfdbfsdbsfb", page, limit);
      const { status, result, count } = await getsupportTicket({
        address: user,
        page: page,
        limit: limit,
      });
      if (status && result.length > 0) {
        const recordfilter = result.map((ticket, index) => ({

          ticNo: (
            <p className="exchange_table_values m-0 text-center">{incIndex + 1 + index}</p>
          ),
          walletAddress: (
            <p className="exchange_table_values m-0 text-center">
              {ticket.walletAddress}
            </p>
          ),
          severity: (
            <p className="exchange_table_values m-0 text-center">
              {ticket.severity}
            </p>
          ),
          dateofRise: (
            <p className="exchange_table_values m-0 text-center">
              {momentFormat(ticket.createdAt)}
            </p>
          ),
          status: (
            <p className="exchange_table_values m-0 text-center">
              {ticket.status}
            </p>
          ),
          dateofClosed: (
            <p className="exchange_table_values m-0 text-center">
              {momentFormat(ticket.updatedAt)}
            </p>
          ),
          // "details": <p className='exchange_table_values m-0 text-center'>{ticket.walletAddress}</p>,
        }));
        setrecords(recordfilter);

        console.log("Filtered records", recordfilter, records);
      } else {
        setrecords([]);
      }
    } catch (error) {
      console.error("Error fetching support tickets:", error);
    }
  }

  const state = {
    records: records ?? [],
  };

  const columns = [
    {
      key: "ticNo",
      text: "Ticket No",
      className: "nameS",
      align: "center",
      sortable: false,

    },
    {
      key: "walletAddress",
      text: "Wallet Address",
      className: "walletAddress",
      align: "center",
      sortable: false,
    },
    {
      key: "severity",
      text: "Severity",
      className: "severity",
      align: "center",
      sortable: false,
    },
    {
      key: "dateofRise",
      text: "Date Of Rise",
      className: "dateofRise",
      align: "center",
      sortable: false,
    },
    {
      key: "status",
      text: "Status",
      className: "status",
      align: "center",
      sortable: false,
    },

    {
      key: "dateofClosed",
      text: "Date of Closed",
      className: "dateofClosed",
      align: "center",
      sortable: false,
    },
    // {
    //   key: "details",
    //   text: "Details",
    //   className: "details",
    //   align: "center",
    //   sortable: false,
    // },
  ];

  const config = {
    page_size: limit,
    length_menu: [10, 20, 50],
    filename: "Emailtemplates",
    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      no_data_text: "No Data found!",
      loading_text: "No Data found",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: "Previous",
        next: "Next",
        last: "Last",
      },
    },
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: false,
  };

  const extraButtons = [
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
    },
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
      onDoubleClick: (event) => {
        console.log("doubleClick");
      },
    },
  ];

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Container fluid className="p-0 position-relative common_bg supportticket">
        {/* <img
          src={Images.radiantBlur}
          className="home__dashboardLeftBlur img-fluid"
          alt=""
        />
        <img
          src={Images.radiantBlur}
          className="home__dashboardRightBlur img-fluid"
          alt=""
        /> */}
        {/* <LandingHeader /> */}
        <Header />
        <Container fluid className="p-0 custom_container">
          <Container className="home__indexAligner innerpages_ui">
            <div className="plans__holder">
              <h4 className="m-0 hebrew_bold opportunity__title">
                Support Tickets
              </h4>
              {/* <input type='text' className='transacHistory__input hebrew_font w-100 rounded-1 mt-2' placeholder='Search with TXN Hash'/> */}
              <div className="dashboard__blueBox rounded-2 mt-5">
                <div className="d-flex justify-content-center">
                  <h4 className="m-0 hebrew_bold dashboard__midGrad  py-3">
                    Raise a Ticket
                  </h4>
                </div>
                <div className="transacHistory__tableHolder">
                  <ReactDatatable
                    config={config}
                    records={state.records}
                    columns={columns}
                    extraButtons={extraButtons}
                    dynamic={true}
                    total_record={count}
                    onChange={(e) => {
                      handlePagination(e);
                    }}
                  // loading={true}
                  />
                </div>

                <div className="text-center mt-5 pb-4">
                  <NavLink to="/ticketManagement">
                    <button
                      className="secondary_btn cmnModal_secondaryBtn rounded-5 primary_gradBtnWidth hebrew_strong"
                      data="Create New Ticket"
                    ></button>
                  </NavLink>
                </div>
              </div>
            </div>
          </Container>
        </Container>
        {/* <InnerFooter /> */}
        <NewFooter />
      </Container>
    </>
  );
};

export default SupportTicket;
